import React from 'react';
import { Box, Typography, Link, keyframes } from '@mui/material';
import { Lightbulb } from '@mui/icons-material';
import { getPageRoute } from 'src/services';

// Floating circles animation
const floatCircles = keyframes`
  0%, 100% { transform: translate(0, 0) scale(1); opacity: 0.6; }
  33% { transform: translate(10px, -5px) scale(1.1); opacity: 0.8; }
  66% { transform: translate(-5px, 5px) scale(0.9); opacity: 0.4; }
`;

const GoogleCalendarUpsell = () => {
  return (
    <Box sx={{ 
      position: 'relative',
      display: 'flex', 
      alignItems: 'flex-start', 
      gap: 1.5, 
      mt: 2,
      p: 3,
      borderRadius: '12px',
      background: 'linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)',
      border: '1px solid #e9ecef',
      overflow: 'hidden',
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04), 0 1px 2px rgba(0, 0, 0, 0.08)'
    }}>
      {/* Floating circles */}
      <Box sx={{
        position: 'absolute',
        top: -5,
        left: 20,
        width: 8,
        height: 8,
        borderRadius: '50%',
        backgroundColor: 'rgba(0, 0, 0, 0.15)',
        animation: `${floatCircles} 3s ease-in-out infinite`
      }} />
      <Box sx={{
        position: 'absolute',
        top: 15,
        right: 30,
        width: 6,
        height: 6,
        borderRadius: '50%',
        backgroundColor: 'rgba(0, 0, 0, 0.12)',
        animation: `${floatCircles} 4s ease-in-out infinite 1s`
      }} />
      <Box sx={{
        position: 'absolute',
        bottom: 5,
        left: 60,
        width: 4,
        height: 4,
        borderRadius: '50%',
        backgroundColor: 'rgba(0, 0, 0, 0.18)',
        animation: `${floatCircles} 2.5s ease-in-out infinite 0.5s`
      }} />
      
      <Lightbulb sx={{ fontSize: 18, mt: 0.1, zIndex: 1 }} />
      <Typography variant="body1" sx={{ zIndex: 1 }}>
        Try{" "}
        <Link 
          href={getPageRoute("help", "SUBSCRIBING_GOOGLE_CALENDAR_STEPS")}
          sx={{ cursor: "pointer", textDecoration: "underline", fontWeight: 600 }}
        >
          Google Connect
        </Link>
        {" "}that uses Google Calendar's API to push events directly to your calendar — no waiting, no delays.
        <br /><br />
        <Link 
          href={getPageRoute("help", "SUBSCRIBING_GOOGLE_CALENDAR_STEPS")}
          sx={{ cursor: "pointer", textDecoration: "underline" }}
        >
          Learn more here
        </Link>
        .
      </Typography>
    </Box>
  );
};

export default GoogleCalendarUpsell;